















































import { BButton, BFormGroup, BFormInput, BModal } from "bootstrap-vue";
import { ref, computed, defineComponent, PropType, watch } from "@vue/composition-api";
import Preview from "@/views/modules/settings/whatsapp-templates/components/preview.vue";
import { TemplateInterface } from "@/interfaces/template.interface";

export default defineComponent({
    components: {
        BFormInput,
        BFormGroup,
        BButton,
        BModal,
        Preview,
    },
    props: {
        template: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
        value: {
            // Required false because variables can be undefiend
            required: false,
            type: Array as PropType<string[] | undefined>,
        },
    },
    setup(props, { emit }) {
        const inputSamples = computed<string[]>({
            get: () => props.value ?? [],
            set: (value) => emit("input", value.length ? value : undefined),
        });

        const variableRegex = /\{\{([^}]+)}}/g;

        const inputSampleVars = computed(
            () =>
                props.template.content.match(variableRegex)?.map((variable, index) => ({
                    index,
                    name: variable,
                })) ?? []
        );

        // If variable count changes reset the examples
        watch(
            () => inputSampleVars.value.length,
            () => {
                // Don't change examples if the example lenght also changed to the same amount
                if (inputSamples.value.length === inputSampleVars.value.length) {
                    return;
                }

                inputSamples.value = inputSampleVars.value.map(() => "");
            },
            { immediate: true }
        );

        return {
            inputSamples,
            inputSampleVars,
        };
    },
});
